import React from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { birthdayBannerText, wishPreview } from "./voBirthday";

export default function VoBirthdayBar({
  people = [],
  wishes = [],
  selfUserId = 0,
  onCongratulate,
}) {
  const title = birthdayBannerText(people);
  if (!title) return null;
  const honorees = people.filter((row) => Number(row.userId) !== Number(selfUserId));
  const canSend = honorees.length > 0;
  return (
    <Box
      data-vo-birthday-bar="1"
      sx={{
        position: "relative",
        pointerEvents: "auto",
        width: "100%",
        px: 1.35,
        py: 0.9,
        borderRadius: 2,
        bgcolor: "rgba(48, 24, 40, 0.82)",
        border: "1px solid rgba(255,196,220,0.28)",
        backdropFilter: "blur(10px)",
        textAlign: "left",
      }}
    >
      <Typography sx={{ fontSize: "0.92rem", fontWeight: 800, color: "#ffe3f0" }}>
        🎂 {title}
      </Typography>
      {canSend ? (
        <Button
          size="small"
          onClick={() => onCongratulate?.(honorees[0])}
          sx={{
            mt: 0.6,
            textTransform: "none",
            fontWeight: 800,
            color: "#3a2414",
            bgcolor: "#f3c4d8",
            borderRadius: 999,
            px: 1.5,
            "&:hover": { bgcolor: "#f8d4e4" },
          }}
        >
          Mandar parabéns
        </Button>
      ) : (
        <Typography sx={{ mt: 0.4, fontSize: "0.72rem", color: "#f8d4e4" }}>
          O time pode te mandar um presente virtual
        </Typography>
      )}
      {wishes.length ? (
        <Stack direction="row" spacing={0.6} flexWrap="wrap" useFlexGap justifyContent="center" sx={{ mt: 0.75 }}>
          {wishes.slice(0, 4).map((wish) => (
            <Chip
              key={wish.id}
              size="small"
              label={wishPreview(wish)}
              sx={{
                height: 22,
                fontWeight: 700,
                color: "#fff6fa",
                bgcolor: "rgba(255,255,255,0.1)",
              }}
            />
          ))}
        </Stack>
      ) : null}
    </Box>
  );
}
